<template>
  <div class="article-info" v-if="article!=null">
    <h1><div class="article-title"> {{ article.title}}</div></h1>
    <div class="article-author">
      <span>来源：<span v-if="article.source">{{ article.source }}</span><span v-else>-</span></span>
      作者：<span v-if="article.author">{{ article.author }}</span><span v-else>-</span>
    </div>
    <div class="article-time">
      <div v-if="article.createTime">{{ article.createTime }}</div>
    </div>
    <div class="article-content" v-html="article.content"></div>

    <div class="article-editor">
      <div style="margin-bottom: 10px;">编辑：<span v-if="article.editor">{{ article.editor }}</span><span v-else>-</span></div>
<!--      <div></div>-->
    </div>
    <div class="article-footer">

    </div>
  </div>
  <div v-else>
    <div class="article-title">文章不存在或已经下架</div>
  </div>
</template>

<script>
import api from "@/api/index";

export default {

data() {
  return {
    id:'',
    article:{}
  }
},
created() {
  this.id = this.$route.params.id;
  this.articleInfo(this.id)



  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?fe9233b0d5128a858ad38b14c5bdf8c8";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
},
 methods: {
    articleInfo(articleId) {
      api.articleInfo(articleId).then(res => {
        console.log(res);
        if (res.code === 200){
          this.article = res.data;
          document.title =this.article.title;
        }else {
          this.article = null;
          //this.$router.push('/404');
        }
      })
    },
   formatTime(time) {
     const date = new Date(time);
     return date.toLocaleString(); // 根据本地时区格式化日期
   }
 }
}

</script>
<style scoped>
  .article-info{
    width: 95%;
    margin-left: 10px;
  }
  .article-title{
    margin-top: 10px;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }
  .article-author{
    font-size: 14px;
    color: #646d81;
   /* text-align: center;*/
  /*  float: left;*/
    margin-bottom: 5px;
  }


  .article-time{
    font-size: 14px;
    color: #646d81;
   /* float: left;*/
  }
  .article-author span{
    margin-right: 5px;
  }
  .article-content{
    font-size: 18px;
    line-height: 2em;
    padding-top: 10px;

  }
  .article-editor{
    padding: 10px 0 10px;
    margin: 0 10px 0 10px;
    text-align: right;
    font-size: 12px
  }
 /* .article-footer{
    padding: 20px 0 10px;
  }*/
</style>
